export default {
    cn: {
        mainView: {
            sidebarList: {
                userMaintenance: '用户管理',
                roleMaintenance: '角色管理',
                changePassword: '修改密码',
                symbol: '产品列表',
                logout: "登出",
                auditLog: '审核记录',
                dayTradeReport: '短线平仓及盈利单报告',
                positionReport: '未平仓报表',
                bBookReport: 'B-Book 报表',
                clientReport: '客户报表',
                closedTradesReport: '交易价值报表',
                mt4ClosedTradesReport: 'MT5已平仓报表 (Dealing)',
                mt4DepositWithdrawlReport: 'MT5出入金报表 (Dealing)',
                mt4CreditReport: 'MT5信用额报表 (Dealing)',
                mt4SummaryReport: 'MT5总结报表 (Dealing)',
                mt4SeregatedReport: 'MT5实时盈亏报表 (Dealing)',
                mt4EquityReport: 'MT5净值报表 (Dealing)',
                mt4EquityMultiReport: 'MT5净值报表(Dealing)(Multi)',
                mt4ProfitLossReport: 'MT5盈亏报表 (Dealing)',
                mt4AccountReport: 'MT5账号报表 (Dealing)',
                accountAnalyze: '账户分析报表',
                symbolProfit: '产品盈亏报表',
                downloadReport: '下载报表',
                monitorAccounts: '监察客户名单',
                floatingPL: '客户浮动盈亏统计',
                openTradeStat: '未平仓交易统计',
                managerOperateRecord: 'MT5经理操作记录',
                loginRecord: 'MT5登录记录',
                profitTopList: '盈利Top榜',
                autoPositionReportConfig: '自动报仓配置',
                autoUpdateLeverage: '自动更新杠杆配置',
                chargeDividends: '利息自动计算配置',
                annualInterestBonus: '账户余额分红',
            },
            currentManLogin: '当前经理账号：',
            exit: '退出'
        }
    },
    hk: {
        mainView: {
            sidebarList: {
                userMaintenance: '用戶管理',
                roleMaintenance: '角色管理',
                changePassword: '修改密碼',
                symbol: '產品列表',
                logout: "登出",
                auditLog: '審核記錄',
                dayTradeReport: '短線平倉及盈利單報告',
                positionReport: '未平倉報表',
                bBookReport: 'B-Book 報表',
                clientReport: '客戶報表',
                closedTradesReport: '交易價值報表',
                mt4ClosedTradesReport: 'MT5已平倉報表 (Dealing)',
                mt4DepositWithdrawlReport: 'MT5出入金報表 (Dealing)',
                mt4CreditReport: 'MT5信用額報表 (Dealing)',
                mt4SummaryReport: 'MT5總結报表 (Dealing)',
                mt4SeregatedReport: 'MT5實時盈虧報表 (Dealing)',
                mt4EquityReport: 'MT5淨值報表 (Dealing)',
                mt4EquityMultiReport: 'MT5淨值報表(Dealing)(Multi)',
                mt4ProfitLossReport: 'MT5盈虧報表 (Dealing)',
                mt4AccountReport: 'MT5賬號報表 (Dealing)',
                accountAnalyze: '賬戶分析報表',
                symbolProfit: '產品盈虧報表',
                downloadReport: '下載報表',
                monitorAccounts: '監察客戶名單',
                floatingPL: '客戶浮動盈虧統計',
                openTradeStat: '未平倉交易統計',
                managerOperateRecord: 'MT5經理操作記錄',
                loginRecord: 'MT5登錄記錄',
                profitTopList: '盈利Top榜',
                autoPositionReportConfig: '自動報倉配置',
                autoUpdateLeverage: '自動更新槓桿配置',
                chargeDividends: '利息自動計算配置',
                annualInterestBonus: '賬戶餘額分紅',
            },
            currentManLogin: '當前經理賬號：',
            exit: '退出'
        }
    },
    en: {
        mainView: {
            sidebarList: {
                userMaintenance: 'User Maintenance',
                roleMaintenance: 'Role Maintenance',
                changePassword: 'Change Password',
                symbol: 'Symbol List',
                logout: "Logout",
                auditLog: 'Audit Log',
                dayTradeReport: 'Day Trade Report',
                positionReport: 'Open Deal Report',
                bBookReport: 'B-Book Report',
                clientReport: 'Client Report',
                closedTradesReport: 'Trade Value Report',
                mt4ClosedTradesReport: 'MT5 Closed Trades Report (Dealing)',
                mt4DepositWithdrawlReport: 'MT5 Deposit And Withdrawl Report (Dealing)',
                mt4CreditReport: 'MT5 Credit Report (Dealing)',
                mt4SummaryReport: 'MT5 Summary Report (Dealing)',
                mt4SeregatedReport: 'MT5 Segregated Report (Dealing)',
                mt4EquityReport: 'MT5 Equity Report (Dealing)',
                mt4EquityMultiReport: 'MT5 Equity Report (Dealing)(Multi)',
                mt4ProfitLossReport: 'MT5 Profit And Loss Report (Dealing)',
                mt4AccountReport: 'MT5 Account Report (Dealing)',
                accountAnalyze: 'Account Analyze Report',
                symbolProfit: 'Symbol Profit Report',
                downloadReport: 'Download Report',
                monitorAccounts: 'Monitor Accounts',
                floatingPL: 'Client Floating PL Statistics',
                openTradeStat: 'Open Trades Statistics',
                managerOperateRecord: 'MT5 Manager Operate Record',
                loginRecord: 'MT5 Login Record',
                profitTopList: 'Profit Top List',
                autoPositionReportConfig: 'Auto Position Report Configuration',
                autoUpdateLeverage: 'Auto Update Leverage Configuration',
                chargeDividends: 'Charge Dividends Configration',
                annualInterestBonus: 'Annual Interest Bonus Configration',
            },
            currentManLogin: 'Current Manager：',
            exit: 'Exit'
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/mainView.js